// src/pages/Media.js
import React, { useState } from 'react';
import './Media.css';

// --- Lightbox Imports ---
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';


// --- Dynamic Image Import for Newspaper Cuttings ---
const importAll = (r) => {
  // This function simply returns an array of imported image modules (paths).
  // We will provide generic titles directly in the component.
  return r.keys().map(r);
};

// Use require.context to get all image files from the specified directory.
// Make sure your newspaper cuttings are in this folder: src/assets/newspaper_cuttings/
const newspaperCuttings = importAll(require.context('../assets/newspaper_cuttings/', false, /\.jpe?g$|\.png$/i));

function Media() {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  return (
    <div className="media-page">

        {/* --- Hero Section --- */}
        <section className="media-hero-section">
          <h1 className="media-hero-heading">Our Stories in the News</h1>
          <p className="media-hero-subheading">
            Showcasing our impact through media recognition.
          </p>
        </section>

      <div className="container">
        {/* --- Cuttings Gallery Section --- */}
        <section className="newspaper-cuttings-section">
          <h2 className="media-section-title">Newspaper Cuttings & Articles</h2>
          <p className="media-intro-text">
            Explore a collection of newspaper clippings and articles featuring Vishwambhara Shikshan Sanstha. These publications highlight our various initiatives, events, and the remarkable achievements of our students and staff. Click on any image to view the full cutting.
          </p>
          <div className="cuttings-grid">
            {newspaperCuttings.length > 0 ? (
              newspaperCuttings.map((cuttingSrc, index) => ( // cuttingSrc is now directly the image path
                <div
                  className="cutting-item"
                  key={index}
                  onClick={() => openLightbox(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    src={cuttingSrc}
                    alt={`Newspaper Cutting ${index + 1}`} // Generic, descriptive alt text
                    className="cutting-image"
                    loading="lazy"
                  />
                  {/* <div className="cutting-overlay">
                    <span className="cutting-caption">View Cutting {index + 1}</span>
                  </div> */}
                </div>
              ))
            ) : (
              <p className="no-cuttings-message">No newspaper cuttings available yet. Please check back soon!</p>
            )}
          </div>

          {/* --- Lightbox Component --- */}
          {isOpen && (
            <Lightbox
              mainSrc={newspaperCuttings[photoIndex]} // Directly use the image path
              nextSrc={newspaperCuttings[(photoIndex + 1) % newspaperCuttings.length]}
              prevSrc={newspaperCuttings[(photoIndex + newspaperCuttings.length - 1) % newspaperCuttings.length]}
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex((photoIndex + newspaperCuttings.length - 1) % newspaperCuttings.length)
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % newspaperCuttings.length)
              }
              imageTitle={`Newspaper Cutting ${photoIndex + 1}`} // Generic title for lightbox
              // Add other Lightbox props as needed
            />
          )}
        </section>

      </div> {/* End .container */}
    </div>
  );
}

export default Media;